import clsx from "clsx";
import Image from "next/image";

function ImageCard(props) {
  var {
    bordered = true,
    imageProps = {
      src: "/images/dummy/blog-dummy-4.jpg",
      alt: "image",
      width: 400,
      height: 240,
    },
    title,
    subTitle = "",
    author = "",
    date = "",
  } = props;
  return (
    <section
      className={clsx(bordered && "border-border-card rounded-lg border")}
    >
      <figure style={{ width: imageProps.width, height: imageProps.height }}>
        <Image
          className={clsx(
            bordered ? "rounded-t-lg" : "rounded-lg",
            imageProps.width && "w-full",
            imageProps.height && "h-full",
          )}
          src={imageProps.src}
          alt={imageProps.alt}
          width={imageProps.width}
          height={imageProps.height}
        />
      </figure>
      <section
        className={clsx("flex flex-col gap-2", bordered ? "p-4" : "pt-4")}
      >
        <span className="text-lg leading-[26px] font-semibold">{title}</span>
        {subTitle && (
          <p className="text-primary-muted-subtext line-clamp-2 text-sm leading-[19px]">
            {subTitle}
          </p>
        )}
        {(author || date) && (
          <div className="mt-[39px] flex flex-col gap-1">
            <span className="leading-[21px] font-medium">{author}</span>
            <span className="text-primary-muted-subtext text-sm leading-[19px]">
              {date}
            </span>
          </div>
        )}
      </section>
    </section>
  );
}

export default ImageCard;
